import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import WorksheetGrid from 'components/worksheet/worksheet_grid';
import WorksheetList from 'components/worksheet/worksheet_list';
import BannerNoticeIndex from 'components/banner_notice/banner_notice_index';
import SeedlangOnly from 'utils/seedlang_only';
import WhitelabelOnly from 'utils/whitelabel_only';

@observer
class WorksheetIndex extends React.Component {

  render() {
    return (
      <>
        <BannerNoticeIndex
          route='worksheets.index'
        />
        <SeedlangOnly>
          <WorksheetList
            {...this.props}
          />
        </SeedlangOnly>
        <WhitelabelOnly>
          <WorksheetGrid
            useGridSection
            showFilters
            {...this.props}
          />
        </WhitelabelOnly>
      </>
    );
  }
}

export default ErrorBoundary(WorksheetIndex);
